import constants from 'constants/index'

const isRegulationVersionValid = (regulationVersion) => {
  const now = new Date()

  if (regulationVersion?.status !== constants.regulations.STATUS.ACTIVE)
    return false
  if (regulationVersion?.startsAt && new Date(regulationVersion.startsAt) > now)
    return false
  if (regulationVersion?.endsAt && new Date(regulationVersion.endsAt) <= now)
    return false

  return true
}

export default isRegulationVersionValid
